import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import styles from './Search.module.scss';

interface SearchProps {
    placeholder?: string;
    className?: string;
    onSearch: (text: string) => void;
}

export const Search: FunctionComponent<SearchProps> = props => {
    const debounced = useDebouncedCallback(value => {
        props.onSearch(value);
    }, 100);

    return (
        <input
            placeholder={props.placeholder ?? 'Search'}
            onFocus={event => event.target.select()}
            className={clsx(styles.input, props.className)}
            onChange={event => debounced(event.target.value)}
        />
    );
};

export default Search;
